import * as Sentry from "@sentry/vue";
import axios from 'axios';

import { API_URL, FEATURE_REQUEST, SET_FEATURE_REQUEST, SET_NOTIFICATION } from "@/store/constant";

const state = { features: null }

const getters = {
  features: state => state.features
}

const actions = {
  [FEATURE_REQUEST]: ({ commit }) => {
    commit(SET_FEATURE_REQUEST, null)
    return axios({ url: `${API_URL}/features` })
      .then(resp => {
        commit(SET_FEATURE_REQUEST, resp.data);
      })
      .catch(err => {
        commit(SET_NOTIFICATION,{ type: 'error', messages: err.response.data.message[0].messages });
        Sentry.captureException(err);
      });
  }
}

const mutations = {
  [SET_FEATURE_REQUEST]: (state, payload) => {
    state.features = payload;
  }
}

export default { state, getters, actions, mutations }
